function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "p.0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0l200.0 0l0 200.0l-200.0 0l0 -200.0z",
  clipRule: "nonzero"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#p.0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m0 0l200.0 0l0 200.0l-200.0 0z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "p.1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(10.148522070022429 0.0 0.0 10.148522070022429 0.0 0.0)",
  spreadMethod: "pad",
  x1: 4.7794513608426366,
  y1: 4.779414486429009,
  x2: 4.779414486429009,
  y2: 14.927936556384449
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4d4d4d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000000"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "url(#p.1)",
  d: "m48.504368 100.00043l0 0c0 -28.44049 23.055569 -51.49606 51.49606 -51.49606l0 0c13.657608 0 26.755836 5.425461 36.413223 15.082848c9.657379 9.657383 15.08284 22.755611 15.08284 36.41321l0 0c0 28.44049 -23.055573 51.496063 -51.496063 51.496063l0 0c-28.44049 0 -51.49606 -23.055573 -51.49606 -51.496063z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#ffffff",
  strokeWidth: 8,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m48.504368 100.00043l0 0c0 -28.44049 23.055569 -51.49606 51.49606 -51.49606l0 0c13.657608 0 26.755836 5.425461 36.413223 15.082848c9.657379 9.657383 15.08284 22.755611 15.08284 36.41321l0 0c0 28.44049 -23.055573 51.496063 -51.496063 51.496063l0 0c-28.44049 0 -51.49606 -23.055573 -51.49606 -51.496063z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "m98.78262 64.37825l0 0c9.845459 -7.3232117 25.490814 -3.0082245 34.944885 9.6377945c9.454071 12.646011 9.136795 28.834267 -0.70866394 36.15748l0 0c4.0829315 -9.252983 1.9311218 -21.630394 -5.4850693 -31.550476c-7.4161835 -9.92009 -18.695404 -15.508396 -28.751152 -14.244797z",
  fillRule: "evenodd"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 200.0 200.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bdea8b58.svg";
export { ForwardRef as ReactComponent };